const C = {
  crimson: "#C8003E", amber: "#F5A623", darkBg: "#000000ff",
  cardBg: "#1A1D24", border: "#2A2D35", text: "#FFFFFF",
  muted: "#8B90A0", danger: "#EF4444", success: "#22C55E", indigo: "#6366F1",
};

export function Pagination({ total, page, perPage, onChange }) {
  const totalPages = Math.ceil(total / perPage);
  if (totalPages <= 1) return null;

  // janela de páginas: sempre mostra no máximo 5 botões numéricos
  const half = 2;
  let start = Math.max(1, page - half);
  let end   = Math.min(totalPages, page + half);
  if (end - start < 4) {
    if (start === 1) end   = Math.min(totalPages, start + 4);
    else             start = Math.max(1, end - 4);
  }
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);

  const btn = (label, target, disabled, active = false) => (
    <button
      key={label}
      onClick={() => !disabled && onChange(target)}
      disabled={disabled}
      style={{
        minWidth: 32, height: 32, padding: "0 8px",
        background: active ? C.crimson : "transparent",
        color: disabled ? C.muted : active ? "#fff" : C.muted,
        border: `1px solid ${active ? C.crimson : C.border}`,
        borderRadius: 6, fontSize: 12, fontWeight: active ? 700 : 400,
        cursor: disabled ? "default" : "pointer",
        transition: "background 0.12s, border-color 0.12s",
        fontFamily: "inherit",
      }}
      onMouseEnter={e => { if (!disabled && !active) e.currentTarget.style.background = `${C.crimson}22`; }}
      onMouseLeave={e => { if (!disabled && !active) e.currentTarget.style.background = "transparent"; }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderTop: `1px solid ${C.border}` }}>
      <span style={{ fontSize: 11, color: C.muted }}>
        {total} clientes · pág. {page} de {totalPages}
      </span>
      <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
        {btn("«", 1,         page === 1)}
        {btn("‹", page - 1,  page === 1)}
        {start > 1 && <span style={{ color: C.muted, alignSelf: "center", fontSize: 12 }}>…</span>}
        {pages.map(p => btn(p, p, false, p === page))}
        {end < totalPages && <span style={{ color: C.muted, alignSelf: "center", fontSize: 12 }}>…</span>}
        {btn("›", page + 1,  page === totalPages)}
        {btn("»", totalPages, page === totalPages)}
      </div>
    </div>
  );
}